import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationError, NavigationStart, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationErrorRecoveryService {
  private initialized = false;
  private lastNavigationUrl: string | null = null;

  constructor(
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: object,
  ) {}

  init(): void {
    if (this.initialized || !isPlatformBrowser(this.platformId)) return;
    this.initialized = true;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.lastNavigationUrl = event.url;
        return;
      }

      if (!(event instanceof NavigationError) || !this.isLazyChunkError(event.error)) {
        return;
      }

      const targetUrl = this.lastNavigationUrl || event.url;
      if (!targetUrl) return;

      this.document.location.assign(targetUrl);
    });
  }

  private isLazyChunkError(error: unknown): boolean {
    const message = String((error as any)?.message || error || '').toLowerCase();
    return (
      message.includes('failed to fetch dynamically imported module') ||
      message.includes('importing a module script failed') ||
      message.includes('loading chunk') ||
      message.includes('chunkloaderror')
    );
  }
}
